import React, { useState, useEffect } from "react";
import styled from "styled-components";

const RankLabel = ({
  toDisplay,
  question,
  answeredQuestions,
  setAnsweredQuestions,
  setCurrentPageAnswers,
  currentPage,
  parseDynamicQuestionText
}) => {
  const [isNoneChecked, setIsNoneChecked] = useState(
    answeredQuestions[currentPage - 1]?.length &&
      answeredQuestions[currentPage - 1]
        .find((answerCode) =>
          answerCode.includes(
            question.Answers[question.Answers.length - 1].AnswerCode
          )
        )
        .includes("=1")
      ? true
      : false
  );

  const [inputValues, setInputValues] = useState(
    [
      ...question.Answers,
      question.Answers.find((obj) => obj.AnswerType === "Other"),
    ].map((obj) => ({
      normal: obj.AnswerType === "Normal" ? "" : null,
      otherText: obj.AnswerType === "Other" ? "" : null,
      otherRank: obj.AnswerType === "Other" ? "" : null,
    }))
  );

  useEffect(() => {
    if (toDisplay && answeredQuestions[currentPage - 1]?.length) {
      let otherValue = answeredQuestions[currentPage - 1]?.find((ans) =>
        ans.includes("_o")
      );
      setInputValues(
        [
          ...answeredQuestions[currentPage - 1]
            .filter(
              (answer) =>
                answer.split("_")[0] ===
                question.Answers[0].AnswerCode.split("_")[0]
            )
            .map((ans) => ({
              normal: ans.includes("_o")
                ? null
                : otherValue && ans.includes(otherValue.split("_o")[0])
                ? null
                : ans.split("=")[1] === "0" || ans.split("=")[1] === "null"
                ? ""
                : ans.split("=")[1],
              otherText: ans.includes("_o")
                ? ans.split("=")[1] === "0" || ans.split("=")[1] === "" || ans.split("=")[1] === "null"
                  ? ""
                  : ans.split("=")[1]
                : null,
              otherRank:
                !ans.includes("_o") &&
                otherValue &&
                ans.includes(otherValue.split("_o")[0])
                  ? ans.split("=")[1] === "0" || ans.split("=")[1] === "null"
                    ? ""
                    : ans.split("=")[1]
                  : null,
            })),
          !otherValue && {
            normal: null,
            otherText: "",
            otherRank: null,
          },
        ].filter((val) => val)
      );

      if (!otherValue) {
        let answeredQuestionsCopy = [...answeredQuestions];

        //for other description
        answeredQuestionsCopy[currentPage - 1]?.push(
          `${
            question.Answers.find((answer) => answer.AnswerType === "Other")
              .AnswerCode
          }_o=-998`
        );

        setAnsweredQuestions(answeredQuestionsCopy);
        setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      }
    }
  }, [toDisplay]);

  useEffect(() => {
    let currentPageAnswers = answeredQuestions[currentPage - 1];
    if (!currentPageAnswers.length) {
      let answeredQuestionsCopy = [...answeredQuestions];
      answeredQuestionsCopy[currentPage - 1] = question.Answers.map(
        (questionObject) => `${questionObject.AnswerCode}=0`
      );

      //for other description
      answeredQuestionsCopy[currentPage - 1]?.push(
        `${
          question.Answers.find((answer) => answer.AnswerType === "Other")
            .AnswerCode
        }_o=-998`
      );

      setAnsweredQuestions(answeredQuestionsCopy);
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    } else {
      let answeredQuestionsCopy = [...answeredQuestions];

      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].map(answer => answer.includes('_o') ? answer.replace('=null', '=-998') : answer.replace('=null', '=0').replace('=-998', '=0'))
      setAnsweredQuestions(answeredQuestionsCopy);
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    }
  }, []);

  const handleNoneCheckboxChange = () => {
    setIsNoneChecked(!isNoneChecked);
    let answeredQuestionsCopy = [...answeredQuestions];
    let otherIndex = answeredQuestionsCopy[currentPage - 1]?.indexOf(
      answeredQuestionsCopy[currentPage - 1]?.find((answerCode) =>
        answerCode.includes("_o=")
      )
    );
    let checkboxIndex = answeredQuestionsCopy[currentPage - 1]?.indexOf(
      answeredQuestionsCopy[currentPage - 1]?.find((answerCode) =>
        answerCode.includes(
          question.Answers[question.Answers.length - 1].AnswerCode
        )
      )
    );

    if (!isNoneChecked) {
      setInputValues(
        question.Answers.map((obj) => ({
          normal: obj.AnswerType === "Normal" ? "" : null,
          otherText: obj.AnswerType === "Other" ? "" : null,
          otherRank: obj.AnswerType === "Other" ? "" : null,
        }))
      );

      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[
        currentPage - 1
      ].map((answer) => `${answer.split("=")[0]}=0`);
      answeredQuestionsCopy[currentPage - 1][otherIndex] = `${
        answeredQuestionsCopy[currentPage - 1][otherIndex].split("=")[0]
      }=-998`;
      answeredQuestionsCopy[currentPage - 1][checkboxIndex] = `${
        answeredQuestionsCopy[currentPage - 1][checkboxIndex].split("=")[0]
      }=1`;
    } else {
      answeredQuestionsCopy[currentPage - 1][checkboxIndex] = `${
        answeredQuestionsCopy[currentPage - 1][checkboxIndex].split("=")[0]
      }=0`;
    }

    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
  };

  const handleInputChange = (index, value, field) => {
    if (field === "normal" || field === "otherRank") {
      if (!/^[123]?$/.test(value)) {
        return;
      }
    }

    let answeredQuestionsCopy = [...answeredQuestions];

    if (field === "otherText") {
       
      let index = answeredQuestionsCopy[currentPage - 1]?.indexOf(
        answeredQuestionsCopy[currentPage - 1]?.find((answerCode) =>
          answerCode.includes("_o")
        )
      );

      const updatedValues = [...inputValues];
      updatedValues[index].otherText = value !== "" && value !== "null" ? value : "-998";

      setInputValues(updatedValues);

      answeredQuestionsCopy[currentPage - 1][index] = `${
        answeredQuestionsCopy[currentPage - 1][index].split("=")[0]
      }=${value !== "" && value !== "null" ? value : "-998"}`;
    } else {
      const updatedValues = [...inputValues];
      updatedValues[index][field] = value;

      setInputValues(updatedValues);

      if (value === "") {
        answeredQuestionsCopy[currentPage - 1][index] = question.Answers[
          index
        ].Expression.replace("_o", "").replace("$Input$", "0");
      } else {
        answeredQuestionsCopy[currentPage - 1][index] = question.Answers[
          index
        ].Expression.replace("_o", "").replace("$Input$", value);
      }
    }

    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
  };

  return (
    <>
      <StyledH2>{parseDynamicQuestionText(question.QuestionName)}</StyledH2>
      {question.Answers.map((obj, index) => {
        if (obj.AnswerType === "Normal") {
          return (
            <Container key={index}>
              <label dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(obj.AnswerLabel, true) }} />
              <Input
                type="text"
                maxLength={2}
                placeholder="Please type a 1, 2, or 3"
                disabled={isNoneChecked}
                value={inputValues[index]?.normal}
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "normal")
                }
                className={isNoneChecked ? "no-border" : ""}
              />
            </Container>
          );
        }

        if (obj.AnswerType === "Other") {
          return (
            <Container key={index}>
              <Input
                type="text"
                placeholder={obj.AnswerLabel}
                disabled={isNoneChecked}
                value={
                  inputValues[inputValues.findIndex((obj) => obj.otherText)]
                    ?.otherText !== "-998" ? inputValues[inputValues.findIndex((obj) => obj.otherText)]
                    ?.otherText : ""
                }
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "otherText")
                }
                className={isNoneChecked ? "no-border" : ""}
              />
              <Input
                type="text"
                maxLength={2}
                placeholder="Please type a 1, 2, or 3"
                disabled={isNoneChecked}
                value={inputValues[index].otherRank}
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "otherRank")
                }
                className={isNoneChecked ? "no-border" : ""}
              />
            </Container>
          );
        }

        if (obj.AnswerType === "None") {
          return (
            <Checkbox className={isNoneChecked ? "checked" : ""} key={index}>
              <input
                type="checkbox"
                checked={isNoneChecked}
                onChange={handleNoneCheckboxChange}
              />
              <span>{obj.AnswerLabel}</span>
            </Checkbox>
          );
        }

        return null;
      })}
    </>
  );
};
const Container = styled.div`
  display: flex;
  width: 820px;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 765px) {
    flex-direction: column;
    margin-left: 10px;
  }

  @media (max-width: 545px) {
    margin-left: 5px;
  }
`;

const StyledH2 = styled.h2`
  width: 870px;

  @media (max-width: 765px) {
    font-size: 18px;
    width: auto;
    margin-left: 10px;
  }  
`

const Input = styled.input`
  width: 383px;
  height: 43px;
  font-size: 16px;
  padding-left: 10px;
  border-radius: 5px;
  border: 2px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;

  ::placeholder {
    color: #cad4e1 !important;
  }

  &:hover {
    border: 2px solid #5bc5cd;
    color: #5bc5cd;
  }

  &:focus {
    border: 2px solid #5bc5cd;
    outline: none;
  }

  &.no-border {
    border-color: transparent;
    background-color: #f0f0f0;
    color: #cad4e1;
  }

  &:disabled {
    opacity: 0.4;
  }

  @media (max-width: 765px) {
    width: 90vw;
    margin-top: 10px;
  }
`;

const Checkbox = styled.label`
  display: flex;
  align-items: center;
  width: 383px;
  height: 43px;
  border-radius: 5px;
  background-color: white;
  padding-left: 10px;
  border: 2px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  cursor: pointer;

  &:hover {
    border: 2px solid #5bc5cd;
    color: #5bc5cd;
  }

  input {
    position: relative;
    width: 25px;
    height: 25px;
    appearance: none;
    border: 2px solid #ace1e5;
    border-radius: 3px;
    background-color: white;
    margin-right: 10px;
    cursor: pointer;

    &:checked {
      background-color: #5bc5cd;
      border: 2px solid #5bc5cd;

      &::before {
        content: "\\2714"; /* Unicode checkmark */
        position: absolute;
        top: -7px;
        left: 1px;
        font-size: 26px;
        color: white;
      }
    }

    &:hover {
      border-color: #5bc5cd;
    }
  }

  &.checked {
    background-color: #e6f6f7;
    border: 2px solid #5bc5cd;

    span {
      color: #5bc5cd;
    }
  }

  @media (max-width: 765px) {
    width: 90vw;
    margin-left: 10px;
  }

  @media (max-width: 545px) {
    margin-left: 5px;
  }
`;

export default RankLabel;
